export default __webpack_public_path__ + "static/media/HamburgerMenu.ca078aea.svg";